import React, { useState, useEffect } from "react";
import { Grid, Typography } from "@material-ui/core";
import AccountSummary from "../../img/account_summary.png";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import Skeleton from "@material-ui/lab/Skeleton";
import moment from "moment";
import { getAssetUrl } from "../../model/service";
import {useTranslation} from 'react-i18next';

const useStyle = makeStyles((theme) => ({
  imgStyle: {
    height: "auto",
    width: "-webkit-fill-available",
    maxWidth: "65px",
  },
  whiteColorFont: {
    color: theme.palette.eWhite?.base,
    padding: "4% 3% 3% 1%"
  },
  mainPadding: {
    padding: "4vh 1vw 1vh 2vw",

  },
  imgGridStyle: {
    padding: "4% 1% 3% 3%",
    display: "flex",
    justifyContent: "flex-end"
  },
}));

export default function E_AmountDue() {
  let classes = useStyle();
  let [assetInfo, setAssetInfo] = useState();
  let meterDetails = useSelector((store) => store?.meterDetails);
  let dateFormat = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.SHORT_DATE_FORMAT
  );
  const {t:labels, ready: labelReady} = useTranslation("label-E_POSTPAID_ACCOUNTSUMMARY");
  let sideImage = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.E_ACCOUNT_SUMMARY_IMAGE
  );

  useEffect(() => {
    getAssetUrl(sideImage).then((res) => setAssetInfo(res))
    .catch(err => setAssetInfo(null))
  }, [sideImage]);

  return (
    <Grid container spacing={3} className={classes.mainPadding}>
      <Grid xs={5} className={classes.imgGridStyle}>
        <img
          src={assetInfo ? assetInfo.assetPath : AccountSummary}
          className={classes.imgStyle}
          // alt={labels([assetInfo?.fallBackLabelKey])}
        />
      </Grid>
      <Grid xs={7} className={classes.whiteColorFont}>
        <Grid container >
          <Grid item xs={12}>
          { labelReady ? <Typography variant="caption">{labels("E_AMOUNT_DUE")}</Typography> : <Skeleton />}
          </Grid>
          {meterDetails?.currentBalance && meterDetails?.curSymbol ? (
            <Grid item xs={12}>
              <Typography variant="h5">
                <b>{meterDetails?.curSymbol + meterDetails?.currentBalance}</b>
              </Typography>
            </Grid>
          ) : (
            <Skeleton />
          )}
          {meterDetails?.latestDueDate && dateFormat && labelReady ? (
            <Grid item xs={12}>
              <Typography variant="subtitle2">
                {labels("E_DUE_DATE")}:{" "}
                {moment(meterDetails?.latestDueDate).format(dateFormat)}
              </Typography>
            </Grid>
          ) : (
            <Skeleton />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
